export default __webpack_public_path__ + "static/media/product-preview-mobile.fe5572bb.jpg";